export default function Maintenance({ message }) {
  const displayMessage = message
    || 'Our site is currently under maintenance.\nThank you for your patience.';

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <h1 style={styles.title}>We'll Be Right Back</h1>
        <p style={styles.text}>
          {displayMessage.split('\n').map((line, idx) => (
            <span key={idx}>
              {line}
              {idx < displayMessage.split('\n').length - 1 ? <br /> : null}
            </span>
          ))}
        </p>
        <p style={styles.hint}>
          If you are a platform administrator, you can still sign in at{' '}
          <a href="/login" style={styles.link}>/login</a>.
        </p>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    height: "100vh",
    width: "100%",
    background: "linear-gradient(135deg, #4e73df, #1cc88a)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "'Segoe UI', sans-serif",
  },
  card: {
    background: "rgba(255, 255, 255, 0.15)",
    padding: "40px 35px",
    borderRadius: "20px",
    textAlign: "center",
    backdropFilter: "blur(10px)",
    color: "#fff",
    width: "90%",
    maxWidth: "450px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
    animation: "fadeIn 1s ease-in-out",
  },
  title: {
    fontSize: "32px",
    marginBottom: "10px",
    fontWeight: 600,
  },
  text: {
    fontSize: "18px",
    opacity: 0.9,
  },
  hint: {
    fontSize: "13px",
    opacity: 0.85,
    marginTop: "18px",
  },
  link: {
    color: "#fff",
    textDecoration: "underline",
  },
};

const animationStyle = document.createElement("style");
animationStyle.innerHTML = `
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
`;
if (typeof document !== "undefined" && document.head) {
  document.head.appendChild(animationStyle);
}
